import axios from 'axios';

export default {
  async getPathFromGeolocationIds(geolocationIds, country = null) {
    if (!geolocationIds || geolocationIds.length === 0) {
      return null;
    }

    try {
      const response = await axios.post(
        'https://feed.lagenhetsbyte.se/sitemap-links',
        {
          country,
          geolocationIds: geolocationIds
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Failed to fetch path from geolocation IDs:', error);
    }

    return null;
  }
};
